module.exports = __webpack_public_path__ + "img/fachada_direction_2_format_2.6e14113c.jpg";